export const stateSelector = (key) => (state) => state?.[key]
export const dictSelector = (state) => state?.lang?.dictionary
export const responseSelector = stateSelector('response')
export const validationDictSelector = (state) =>
  state?.lang?.dictionary?.validation
